module.exports = __webpack_public_path__ + "static/img/starcio.e8ffb856.png";